import { Component, Input, HostListener, ElementRef, forwardRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ParameterService } from '../../../services/parameter.service';
import { DatePipe } from '@angular/common';
import { AlertService } from '../../../services/alert.service';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { MONTHS } from '../../../contants/MONTHS';
import { DateHelper } from '../../../helpers/DateHelper';
import { DAYS_OF_THE_WEEK } from '../../../contants/DAYS_OF_THE_WEEK';
import { DatePeriod } from '../../../models/dates/datePeriod';
import { Week } from '../../../models/dates/week';
import { PARAMS } from '../../../contants/PARAMS';

@Component({
	selector: 'ztsi-date-picker',
	templateUrl: './ztsi-date-picker.component.html',
	styleUrls: ['./ztsi-date-picker.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiDatePickerComponent),
			multi: true
		}
	]
})
export class ZtsiDatePickerComponent implements ControlValueAccessor {
	years: number[] = [];
	months: KeyValuePair[] = MONTHS;
	weeks: Week[] = [];

	dayLabels: KeyValuePair[] = DAYS_OF_THE_WEEK;

	
	showCalendar: boolean = false;

	year = 2018;
	month = 0;
	dateValue: Date = new Date();

	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;
	@Input() selectType: string = 'date';
	@Input() displayFormat: string = 'mediumDate';
	@Output() onValueChange = new EventEmitter();

	onChange: any = () => { };
	onTouched: any = () => { };

	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this._elementRef.nativeElement.contains(event.target))
			this.showCalendar = false;
	}

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();

		this.onValueChange.emit(this._value);
	}

	constructor(
		private _parameterService: ParameterService,
		private _elementRef: ElementRef,
		private _datePipe: DatePipe,
		private _alertService: AlertService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this.getCalendarStartYear(
			() => {
				this.getCalendarStartDay(
					() => {
						this.dateValue =  this.value ? new Date(this.value) : new Date();

						if(this.selectType == 'week'){
							let period = DateHelper.getWeeklyPeriod(this.dateValue , this.dayLabels[0].key);
							this.value = `${period.from}|${period.to}`;
						}

						this.year = this.dateValue.getFullYear();
						this.month = this.dateValue.getMonth();
						this.loadWeeks();
					}
				)
			}
		);
	}

	private getCalendarStartYear(callback?: Function){
		this._parameterService.getCachedSystemParameter(PARAMS.CALENDAR_START_YEAR, 3600).subscribe(
			value => {
				let year = this.dateValue.getFullYear();

				let paramYear = Number(value);
				if (!isNaN(paramYear)) {
					year = paramYear;
				}
				else {
					console.log('Invalid response from server, will use current year instead.');
				}

				this.loadYears(year);

				if(callback){
					callback();
				}
			}
		)
	}

	private getCalendarStartDay(callback?: Function){
		this._parameterService.getCachedSystemParameter<number>(PARAMS.CALENDAR_START_DAY, 3600).subscribe(
			paramResult => {
				this.dayLabels = DateHelper.getDaysLabel(paramResult);

				if(callback){
					callback();
				}
			}
		);
	}

	onDateClick(datePeriod: DatePeriod, date: Date){
		switch(this.selectType){
			case 'week':
				this.value = `${datePeriod.from}|${datePeriod.to}`;
				break;
			case 'month':
				let period = DateHelper.getMonthlyPeriod(date);
				this.value = `${period.from}|${period.to}`;
				break;
			default:
				this.value = DateHelper.getDateString(date);
		}

		this.showCalendar = false;
	}

	loadWeeks() {
		this.weeks = []; //reset
		let period = new DatePeriod();

		let date = new Date(`${this.year}/${Number(this.month) + 1}/1`);
		if(date.getDay() != this.dayLabels[0].key){
			date.setDate(date.getDate() - 1); //subtract 1 to get previous month's week
		}

		let prevMonth = date.getMonth();
		let loopMonth = date.getMonth();
		while(prevMonth == loopMonth || this.month == loopMonth){
			period = DateHelper.getWeeklyPeriod(date, this.dayLabels[0].key);
			let week = new Week(period);
			this.weeks.push(week);

			date = new Date(period.to);
			date.setDate(date.getDate() + 1);
			loopMonth = date.getMonth();
		}
	}

	private loadYears(startYear: number) {
		var computedYear = (new Date()).getFullYear() + 10;
		for (let i = startYear; i <= computedYear; i++) {
			this.years.push(i);
		}
	}

	toggleCalendar(){
		this.showCalendar = !this.showCalendar;
	}

	isSameMonth(date: Date){
		return date.getMonth() == this.month ? true : false;
	}

	getDateDisplay(date: Date){
		let day = date.getDate();
		return day < 10 ? `0${day}` : day;
	}

	getWeekDisplay(){
		let temp = this.value.split('|');
		return `${this._datePipe.transform(temp[0], 'mediumDate')} to ${this._datePipe.transform(temp[1], 'mediumDate')}`;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-date-picker/ztsi-date-picker.component.ts